import prefill from '../prefill';

export default prefill({
  0: {},
  1: {},
  2: {},
  3: {},
  4: {},
});
